import type { Components, Theme } from "@mui/material";

export const MuiTable: Components<Theme>["MuiTable"] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        background: theme.palette.primary.contrastText,
        border: "1px solid #E3E8EF",
        borderRadius: "1rem",
        borderCollapse: "separate",
        borderSpacing: "0 0px",
      };
    },
  },
};
